import gsap from 'gsap'
import { DrawSVGPlugin } from 'gsap/DrawSVGPlugin'
import ScrollTrigger from 'gsap/ScrollTrigger'
import { reduceMotion } from '@js/animations/ReducedMotion'

export class LineDraw {
  constructor () {
    this._elements = document.querySelectorAll('[animation-draw]')

    if (!this._elements.length) {
      return
    }

    this.init()
  }

  init () {
    this._elements.forEach((el) => {
      if (reduceMotion) {
        gsap.set(el, { drawSVG: '0% 100%' })
        return
      }

      gsap.fromTo(
        el,
        { drawSVG: '0% 0%' },
        {
          drawSVG: '0% 100%',
          duration: 1.2,
          ease: 'power2.inOut',
          scrollTrigger: {
            trigger: el,
            start: 'top 90%',
            toggleActions: 'play none none none',
          },
        }
      )
    })
  }
}
